import { render, staticRenderFns } from "./firstCard.vue?vue&type=template&id=1eb78066&scoped=true"
import script from "./firstCard.vue?vue&type=script&lang=js"
export * from "./firstCard.vue?vue&type=script&lang=js"
import style0 from "./firstCard.vue?vue&type=style&index=0&id=1eb78066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb78066",
  null
  
)

export default component.exports